import * as React from "react";

import { Root } from "./CrossfitTableHeaderColumn.styles";

interface CrossfitTableHeaderColumnProps {
    children: React.ReactNode | readonly React.ReactNode[];
    colSpan?: number;
    rowSpan?: number;
    subKind?: "numbers";
    indent?: "1" | "2" | "3" | "4" | "5";
    requiredEmpty?: boolean;
    isNumber?: boolean;
    grouped?: boolean;
    horizontalAlign?: "center" | "left" | "right";
}

export function CrossfitTableHeaderColumn(props: CrossfitTableHeaderColumnProps): JSX.Element {
    if (props.grouped) {
        return <>{props.children}</>;
    }
    return (
        <Root
            subKind={props.subKind}
            indent={Number(props.indent)}
            empty={props.requiredEmpty}
            number={props.isNumber}
            horizontalAlign={props.horizontalAlign}
            colSpan={props.colSpan}
            rowSpan={props.rowSpan}>
            {props.children}
        </Root>
    );
}
